import { Pipe, PipeTransform } from '@angular/core';
import { isNumber, isString, orderBy } from 'lodash';

@Pipe({
    name: 'keyObject',
    standalone: false
})
export class KeyObjectPipe implements PipeTransform {

  transform(keyObject: {[key:string]:any} | undefined) {
    if (keyObject == undefined) {
      return undefined;
    }

    let returnArray = [];
    for (const key in keyObject) {
      if (Object.prototype.hasOwnProperty.call(keyObject, key)) {
        const value = keyObject[key];
        returnArray.push({
          key: key,
          value: value
        })
      }
    }

    return returnArray;
  }
}
